import { FilterSection } from "../../../data-model/filterValues";
import { allPaStatusOptions } from "./filterOptions/paStatusFilterOptions";

export enum CaseAppealsFilterKeys {
  RESPONSE_STATUS = "response_status",
  APPEAL_TYPE = "appeal_type",
  APPEAL_STATUS = "appeal_status",
}

const appealTypeOptions = [
  { label: "Fax", value: "Fax" },
  { label: "Phone", value: "Call" },
  { label: "Portal", value: "E-Appeal" },
  { label: "Mail", value: "Manual" },
];

const appealStatusOptions = [
  { label: "Not Started", value: "Not Started" },
  { label: "In Progress", value: "In Progress" },
  { label: "Submitted", value: "Submitted" },
  { label: "Done", value: "Done" },
  { label: "Appeal Approved", value: "Appeal Approved" },
  { label: "Appeal Denied", value: "Appeal Denied" },
];

/**
 * Builds the static filter sections supported by `pharmacy/appeal/list`.
 *
 * Options do not depend on the loaded rows, so the panel stays usable even when
 * a filter returns no results.
 *
 * @returns Filter sections for the appeals table
 */
export const createAllFilterSections = (): FilterSection[] => {
  return [
    {
      id: CaseAppealsFilterKeys.RESPONSE_STATUS,
      label: "Response Status",
      options: allPaStatusOptions,
      type: "string",
    },
    {
      id: CaseAppealsFilterKeys.APPEAL_TYPE,
      label: "Appeal Type",
      options: appealTypeOptions,
      type: "string",
    },
    {
      id: CaseAppealsFilterKeys.APPEAL_STATUS,
      label: "Appeal Status",
      options: appealStatusOptions,
      type: "string",
    },
  ];
};

/** @deprecated Use {@link CaseAppealsFilterKeys} */
export enum OncologySubmissionFilterKeys {
  DOW = "dumped_at",
  ROUTE_VIA = "route_via",
  PA_STATUS = "pa_status",
  PA_STATUS_BUCKET = "pa_status_bucket",
  CMM = "cmm",
  SENT_TO_CLIENT = "sent_to_client",
}
